/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Banner_ActionInputs */

const en_us2_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const pt_br2_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const es_419_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const pt_pt2_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver`)
};

const fr_fr2_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir`)
};

const de_de2_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansehen`)
};

const it_it2_offline_banner_action = /** @type {(inputs: Offline_Banner_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Offline_Banner_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_banner_action = /** @type {((inputs?: Offline_Banner_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Banner_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_banner_action(inputs)
	if (locale === "es-419") return es_419_offline_banner_action(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_banner_action(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_banner_action(inputs)
	if (locale === "de-DE") return de_de2_offline_banner_action(inputs)
	if (locale === "it-IT") return it_it2_offline_banner_action(inputs)
	return en_us2_offline_banner_action(inputs)
});
export { offline_banner_action as "offline.banner_action" }